import {
  activeNavSupportContent,
  clientHostedSoftwareContent,
  digitalPathologySolutionContent,
  digitalTradeContent,
  hostedServicesContent,
  hylandHostedSolutionContent,
  professionalServicesContent,
  solutionSSTCsContent,
} from "./documents/coveredProductSpecificTermsContent";
import {
  argentinaContent,
  australiaContent,
  austriaContent,
  bahrainContent,
  belgiumContent,
  brazilContent,
  bulgariaContent,
  canadaContent,
  chileContent,
  colombiaContent,
  croatiaContent,
  czechRepublicContent,
  denmarkContent,
  egyptContent,
  europeanUnionContent,
  franceContent,
  germanyContent,
  greeceContent,
  hongKongContent,
  hungaryContent,
  indiaContent,
  indonesiaContent,
  irelandContent,
  jordanContent,
  kingdomOfSaudiArabiaContent,
  kuwaitContent,
  malaysiaContent,
  mexicoContent,
  moroccoContent,
  netherlandsContent,
  newZealandContent,
  peruContent,
  philippinesContent,
  qatarContent,
  romaniaContent,
  singaporeContent,
  slovakiaContent,
  southAfricaContent,
  spainContent,
  sultanateOfOmanContent,
  swedenContent,
  switzerlandContent,
  taiwanContent,
  thailandContent,
  turkeyContent,
  unitedArabEmiratesContent,
  unitedKingdomContent,
} from "./documents/RegionSpecificContent";
import type { TermsAndConditionsDetails } from "./TermsAndConditionsDialog";

export const SIDE_OPTIONS: TermsAndConditionsDetails[] = [
  {
    id: "covered-products",
    label: "Covered Product Specific Terms",
    description:
      "In addition to the above Terms, the following Covered Product specific terms (as set out by the links below) will apply, to the extent such specific products, service, or Software are included in your use of the Covered Products.",
    documents: [
      {
        id: "active-nav-support",
        label: "Active Nav Support",
        content: activeNavSupportContent,
      },
      {
        id: "client-hosted-software",
        label: "Client Hosted (On Premises) Software",
        content: clientHostedSoftwareContent,
      },
      {
        id: "digital-pathology-solution",
        label: "Digital Pathology Solution",
        content: digitalPathologySolutionContent,
      },
      {
        id: "hosted-services",
        label: "Hosted Services",
        content: hostedServicesContent,
      },
      {
        id: "hyland-hosted-solution",
        label: "Hyland Hosted Solution (provided by Iron Mountain)",
        content: hylandHostedSolutionContent,
      },
      {
        id: "professional-services",
        label: "Professional Services",
        content: professionalServicesContent,
      },
      {
        id: "solution-sstcs",
        label: "Solution SSTCs",
        content: solutionSSTCsContent,
      },
      {
        id: "digital-trade",
        label: "Digital Trade",
        content: digitalTradeContent,
      },
    ],
  },
  {
    id: "region-specific",
    label: "Regional Specific Terms",
    description:
      "In addition to the above Terms and Covered Products specific terms (as set out by the links below) the following regional specific terms may apply.",
    documents: [
      {
        id: "argentina",
        label: "Argentina",
        content: argentinaContent,
      },
      {
        id: "australia",
        label: "Australia",
        content: australiaContent,
      },
      {
        id: "austria",
        label: "Austria",
        content: austriaContent,
      },
      {
        id: "bahrain",
        label: "Bahrain",
        content: bahrainContent,
      },
      {
        id: "belgium",
        label: "Belgium",
        content: belgiumContent,
      },
      {
        id: "brazil",
        label: "Brazil",
        content: brazilContent,
      },
      {
        id: "bulgaria",
        label: "Bulgaria",
        content: bulgariaContent,
      },
      {
        id: "canada",
        label: "Canada",
        content: canadaContent,
      },
      {
        id: "chile",
        label: "Chile",
        content: chileContent,
      },
      {
        id: "colombia",
        label: "Colombia",
        content: colombiaContent,
      },
      {
        id: "croatia",
        label: "Croatia",
        content: croatiaContent,
      },
      {
        id: "czech-republic",
        label: "Czech Republic",
        content: czechRepublicContent,
      },
      {
        id: "denmark",
        label: "Denmark",
        content: denmarkContent,
      },
      {
        id: "egypt",
        label: "Egypt",
        content: egyptContent,
      },
      {
        id: "european-union",
        label: "European Union",
        content: europeanUnionContent,
      },
      {
        id: "france",
        label: "France",
        content: franceContent,
      },
      {
        id: "germany",
        label: "Germany",
        content: germanyContent,
      },
      {
        id: "greece",
        label: "Greece",
        content: greeceContent,
      },
      {
        id: "hong-kong",
        label: "Hong Kong",
        content: hongKongContent,
      },
      {
        id: "hungary",
        label: "Hungary",
        content: hungaryContent,
      },
      {
        id: "india",
        label: "India",
        content: indiaContent,
      },
      {
        id: "indonesia",
        label: "Indonesia",
        content: indonesiaContent,
      },
      {
        id: "ireland",
        label: "Ireland",
        content: irelandContent,
      },
      {
        id: "jordan",
        label: "Jordan",
        content: jordanContent,
      },
      {
        id: "kingdom-of-saudi-arabia",
        label: "Kingdom of Saudi Arabia",
        content: kingdomOfSaudiArabiaContent,
      },
      {
        id: "kuwait",
        label: "Kuwait",
        content: kuwaitContent,
      },
      {
        id: "malaysia",
        label: "Malaysia",
        content: malaysiaContent,
      },
      {
        id: "mexico",
        label: "Mexico",
        content: mexicoContent,
      },
      {
        id: "morocco",
        label: "Morocco",
        content: moroccoContent,
      },
      {
        id: "netherlands",
        label: "Netherlands",
        content: netherlandsContent,
      },
      {
        id: "new-zealand",
        label: "New Zealand",
        content: newZealandContent,
      },
      {
        id: "peru",
        label: "Peru",
        content: peruContent,
      },
      {
        id: "philippines",
        label: "Philippines",
        content: philippinesContent,
      },
      {
        id: "qatar",
        label: "Qatar",
        content: qatarContent,
      },
      {
        id: "romania",
        label: "Romania",
        content: romaniaContent,
      },
      {
        id: "singapore",
        label: "Singapore",
        content: singaporeContent,
      },
      {
        id: "slovakia",
        label: "Slovakia",
        content: slovakiaContent,
      },
      {
        id: "south-africa",
        label: "South Africa",
        content: southAfricaContent,
      },
      {
        id: "spain",
        label: "Spain",
        content: spainContent,
      },
      {
        id: "sultanate-of-oman",
        label: "Sultanate of Oman",
        content: sultanateOfOmanContent,
      },
      {
        id: "sweden",
        label: "Sweden",
        content: swedenContent,
      },
      {
        id: "switzerland",
        label: "Switzerland",
        content: switzerlandContent,
      },
      {
        id: "taiwan",
        label: "Taiwan",
        content: taiwanContent,
      },
      {
        id: "thailand",
        label: "Thailand",
        content: thailandContent,
      },
      {
        id: "turkey",
        label: "Turkey",
        content: turkeyContent,
      },
      {
        id: "united-arab-emirates",
        label: "United Arab Emirates",
        content: unitedArabEmiratesContent,
      },
      {
        id: "united-kingdom",
        label: "United Kingdom",
        content: unitedKingdomContent,
      },
    ],
  },
];
